import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, List, Tooltip, Tag, Divider } from "antd";
import { DataCard, GenericCardList } from '@seims/shared';

export const SelectedOrganizations = ({
  selectedOrgs,
  onRemoveContr,
  onShowContributeModal,
  organizationBelongsTo = "project",
  mode="add" // add, edit, view
}) => {
  
  
  const isEventsPwa = organizationBelongsTo === "event";

  const onEdit = (record) => {
    onShowContributeModal(record);
  };

  const onRemove = (record) => {
    onRemoveContr(record);
  };

  const isAddEditMode = ["add", "edit"].includes(mode);  

  return (
    <div className="added-orgs">
      <div>
        <Divider/>
        <h4 style={{fontWeight: "bold"}}>{isEventsPwa ? ("Organisations that are contributing to your event") : (<>Partner(s) that will be added to the {organizationBelongsTo}</>)}</h4>
      </div>

      <GenericCardList
        dataSource={selectedOrgs}
        
        renderItem={(item, index) => {
          const typeLabel = item.type && item.type.trim().length > 0 ? item.type : item.partnerType?.value ?? "N/A";
          const isObjAddress = typeof item.address != "string" && item.address?.province && item.address?.cityOrTown;

          const addressLabel = isObjAddress ? `${item.address.province} (${item.address.cityOrTown})` : item?.address ?? "N/A";

          const cardData = [
            { label: 'Name', value: item.name },
            { label: 'Type', value: typeLabel },
            { label: 'Location', value: addressLabel },
            { label: 'Contributions', value: item?.contributions?.map((v) => (<Tag key={`contribution-${v.value}`}>{v?.label}</Tag>)) ?? <Tag color="red">No Contributions</Tag> }
          ];

          return (
            <List.Item>
              <DataCard
                disabled={ !(["edit", "add"].includes(mode))}
                index={index}
                isSelected={true}
                onToggleSelect={() => {}}
                details={cardData}
                actions={[
                  <Tooltip
                  title={`Remove Contributing ${isEventsPwa ? "Organization" : "Partner"}`}
                  key="remove-contributing-org-tooltip"
                  placement="top"
                  trigger={["hover", "click"]}
                  >
                    <Button
                    disabled={!isAddEditMode}
                      key="remove-contributing-org"
                      type="text"
                      danger
                      icon={<DeleteOutlined />}
                      shape={`${isEventsPwa ? "circle" : "round"}`}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent card click
                        onRemove(item.id);
                      }}
                    >{isEventsPwa ? " " : " Remove"}</Button>
                  </Tooltip>,
                  <Tooltip
                    title={`Edit ${isEventsPwa ? "Organization" : "Partner"} Contributions`}
                    key="edit-contributing-org-tooltip"
                    placement="top"
                    trigger={["hover", "click"]}
                    >
                    <Button
                      disabled={!isAddEditMode} // Editing contribution always allowed?
                      key="edit-contributing-org"
                      type="text"
                      shape={`${isEventsPwa ? "circle" : "round"}`}
                      color="blue"
                      icon={<EditOutlined about={`Edit ${isEventsPwa ? "Organization" : "Partner"} Contributions`} />}
                      style={{ color: "#1677ff" }} // Primary blue color
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent card click
                        onEdit(item);
                      }}
                    >{isEventsPwa ? " " : " Edit"}</Button>
                  </Tooltip>
                ]}
              />
            </List.Item>
          );
        }}
      />
  </div>
);
};
